import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {SpecialistViewInterface} from '@interfaces/specialist.interface';
import {SpecialistDataFlowService} from '../services/specialist-data-flow.service';
import {SpecialistInterfaces} from '@namespaces/specialist.namespace';
import {PreviewModalService} from '@services/preview-modal.service';

@Component({
    selector: 'app-specialist-view-tab-education',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './specialist-view-tab-education.component.html'
})

export class SpecialistViewTabEducationComponent {
    @Input() specialist: SpecialistViewInterface;

    constructor(
        private dataService: SpecialistDataFlowService,
        private previewService: PreviewModalService,
    ) {
    }

    onAddClick() {
        this.dataService.addPermit$.next();
    }

    showPermit(permit: SpecialistInterfaces.Permit) {
        this.previewService.show({
            title: permit.type_title,
            files: permit.files,
        });
    }
}
